export class IdeEditor {
  public Editor: string;

  public Lookup: string;

  public Title: string;

  public Toolkit: string;
}
